module.exports = __webpack_public_path__ + "img/icon-employees-light.43f99deb.svg";